import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {TableService} from "./pager";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpParams} from "@angular/common/http";
import {FormControl} from "@angular/forms";
import {WebService} from "../services/web/web.service";
import {SpinnerService} from "../services/spinner/spinner.service";
import {ToastService} from "../services/notification/toast.service";
import {MatTableDataSource} from "@angular/material/table";
import {AppliedChargesFilter} from "./applied-charges.filter";
import {SecurityService} from "../services/security.service";
import {TranslateService} from "@ngx-translate/core";
import {EMPTY, forkJoin, Observable, of, Subject} from "rxjs";
import {catchError, debounceTime, distinctUntilChanged, expand, finalize, map, reduce, takeUntil, tap} from "rxjs/operators";
import {BatchProcessingService} from "../batch-processing/batch-processing.service";
import {FileProcess} from "../batch-processing/batch-processing.models";
import {UserPermissionsService} from "../services/user-permissions.service";

@Component({
    selector: 'app-applied-charges',
    templateUrl: './applied-charges.component.html',
    styleUrls: ['./applied-charges.component.scss'],
    standalone: false
})
export class AppliedChargesComponent implements OnInit, OnDestroy {

    // TODO: Cambiar a false cuando el endpoint esté disponible
    private useMock = false;
    private readonly CHARGED_STATUS = 'charged';
    private readonly UNCHARGED_STATUS = 'not_charged';
    readonly ERROR_DESCRIPTION_MAX_LENGTH = 45;

    isOpenSearchPanel = false;
    filter = new AppliedChargesFilter();
    chargeStatusOptions: Array<{ value: 'charged' | 'not_charged'; labelKey: string }> = [
        { value: this.CHARGED_STATUS, labelKey: 'appliedCharges.search.charged' },
        { value: this.UNCHARGED_STATUS, labelKey: 'appliedCharges.search.notCharged' }
    ];

    partners: any[] = [];
    selectedPartnerId: string | undefined;
    selectedFile: FileProcess | null = null;
    appliedChargeStatus: 'charged' | 'not_charged' | null = null;
    fileControl = new FormControl<string | FileProcess>({value: '', disabled: true});
    allFileOptions: FileProcess[] = [];
    fileOptions: FileProcess[] = [];
    loadingFiles = false;
    private pendingFileProcessId: number | null = null;
    private readonly destroy$ = new Subject<void>();
    private readonly allowedFileStatuses = ['PROCESSED', 'COMPLETED', 'NOTIFIED'];
    @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
    @ViewChild(MatSort) sort: MatSort | undefined;
    displayedColumns: string[] = [
        'partnerName',
        'invoiceCode',
        'clientName',
        'chargeType',
        'totalInvoice',
        'mask',
        'createdAtInvoice',
        'approvalDate',
        'authorizationNumber'
    ];
    private readonly BASE_DISPLAYED_COLUMNS = [...this.displayedColumns];

    dataSource: any;    private readonly HEADER_MAPPING: any = {
        partnerName: 'Compañía',
        invoiceCode: 'Código Factura',
        identifierCustomer: 'Identificación Cliente',
        clientName: 'Nombre Cliente',
        chargeType: 'Tipo Cargo',
        totalInvoice: 'Total Factura',
        itbms: 'ITBMS',
        currency: 'Moneda',
        mask: 'Tarjeta',
        createdAtInvoice: 'Fecha Factura',
        approvalDate: 'Fecha Aprobación',
        authorizationNumber: 'Número Referencia',
        resultDescription: 'Descripción del error'
    };

    private readonly EXPORT_COLUMNS: Array<{ key?: string; header: string; width: number }> = [
        { key: 'partnerName', header: 'Comercio', width: 34 },
        { header: '', width: 12 },
        { key: 'invoiceCode', header: 'Referencia', width: 16 },
        { key: 'identifierCustomer', header: 'Cédula', width: 16 },
        { header: '', width: 12 },
        { key: 'clientName', header: 'Cliente', width: 34 },
        { header: '', width: 12 },
        { header: '', width: 12 },
        { key: 'chargeType', header: 'Forma Carga', width: 18 },
        { key: 'totalInvoice', header: 'Monto', width: 14 },
        { header: '', width: 12 },
        { key: 'itbms', header: 'Monto ITBMS', width: 16 },
        { header: '', width: 12 },
        { key: 'currency', header: 'Moneda', width: 10 },
        { key: 'mask', header: 'Tarjeta', width: 12 },
        { header: '', width: 12 },
        { header: '', width: 12 },
        { key: 'createdAtInvoice', header: 'Fecha Corte', width: 16 },
        { key: 'approvalDate', header: 'Fecha Aprob', width: 20 },
        { header: '', width: 12 },
        { header: '', width: 12 },
        { key: 'authorizationNumber', header: 'Autorización', width: 18 }
    ];

    constructor(
        private securityService: SecurityService,
        public tableService: TableService<any>,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private cdr: ChangeDetectorRef,
        private webService: WebService,
        private batchProcessingService: BatchProcessingService,
        private spinner: SpinnerService,
        private toast: ToastService,
        private translate: TranslateService,
        private userPermissionsService: UserPermissionsService
    ) {
        this.tableService = new TableService;
    }

    ngOnInit(): void {
        this.isOpenSearchPanel = true;
        this.applyQueryParamsToState();
        this.initializeFileSearch();
        this.loadPartners();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    get showErrorDescriptionColumn(): boolean {
        return this.appliedChargeStatus === this.UNCHARGED_STATUS;
    }

    onChargeStatusChange(): void {
    }

    private updateDisplayedColumns(): void {
        this.displayedColumns = this.showErrorDescriptionColumn
            ? [...this.BASE_DISPLAYED_COLUMNS, 'resultDescription']
            : [...this.BASE_DISPLAYED_COLUMNS];
    }

    private applyQueryParamsToState(): void {
        const q = this.activatedRoute.snapshot.queryParamMap;

        const partnerId = q.get('partnerId');
        const from = q.get('from');
        const to = q.get('to');
        const chargeStatus = q.get('chargeStatus');
        const processedFileId = q.get('processedFileId') ?? q.get('fileSubscriptionControlId') ?? q.get('fileProcessId');
        const pageIndex = q.get('pageIndex');
        const pageSize = q.get('pageSize');

        if (partnerId) {
            this.selectedPartnerId = partnerId;
            this.filter.partnerId = partnerId;
        }
        if (from) {
            // Convertir de MMDDYYYY a objeto Date
            const month = parseInt(from.substring(0, 2), 10) - 1;
            const day = parseInt(from.substring(2, 4), 10);
            const year = parseInt(from.substring(4, 8), 10);
            this.filter.from = new Date(year, month, day);
        }
        if (to) {
            const month = parseInt(to.substring(0, 2), 10) - 1;
            const day = parseInt(to.substring(2, 4), 10);
            const year = parseInt(to.substring(4, 8), 10);
            this.filter.to = new Date(year, month, day);
        }
        if (chargeStatus === this.CHARGED_STATUS || chargeStatus === this.UNCHARGED_STATUS) {
            this.filter.chargeStatus = chargeStatus;
            this.appliedChargeStatus = chargeStatus;
            this.updateDisplayedColumns();
        }
        if (processedFileId) { this.pendingFileProcessId = Number(processedFileId); }
        if (pageIndex) { this.tableService.pager.pageIndex = Number(pageIndex); }
        if (pageSize) { this.tableService.pager.pageSize = Number(pageSize); }
    }

    private syncUrlQueryParams(): void {
        this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: {
                partnerId: this.selectedPartnerId || null,
                from: this.filter.from ? this.formatDateToISO(this.filter.from as string) : null,
                to: this.filter.to ? this.formatDateToISO(this.filter.to as string) : null,
                chargeStatus: this.filter.chargeStatus || null,
                processedFileId: this.selectedFile?.processedFileId || null,
                pageIndex: this.tableService.pager.pageIndex || null,
                pageSize: this.tableService.pager.pageSize || null
            },
            replaceUrl: true
        });
    }

    private loadPartners(): void {
        this.spinner.open();
        let httpParams = this.webService.buildRequestParams();
        httpParams = httpParams
            .set('parents', 'false')
            .set('parent', '-1')
            .set('identificator_configured', '1');

        this.webService.get(`${this.webService.HOST}/partner/user`, httpParams)
            .subscribe(
                (response: any) => {
                    this.partners = response.result || response || [];

                    // Normalize selectedPartnerId so it matches option values ([value]="String(p.id)")
                    if (this.selectedPartnerId !== undefined && this.selectedPartnerId !== null) {
                        this.selectedPartnerId = String(this.selectedPartnerId);
                        this.filter.partnerId = this.selectedPartnerId;
                    }

                    if (this.partners.length === 1 && !this.selectedPartnerId) {
                        this.selectedPartnerId = this.partners[0].id;
                        this.filter.partnerId = this.partners[0].id;
                    }

                    // If a partnerId came from URL, ensure it exists in the loaded partner list
                    if (this.selectedPartnerId && this.partners.length > 0) {
                        const exists = this.partners.some(p => String(p?.id) === String(this.selectedPartnerId));
                        if (!exists) {
                            this.selectedPartnerId = undefined;
                            this.filter.partnerId = undefined as any;
                        }
                    }

                    const shouldAutoSearch = this.partners.length === 1 ||
                        !!this.activatedRoute.snapshot.queryParamMap.get('partnerId');

                    this.spinner.close();
                    this.cdr.detectChanges();
                    if (this.selectedPartnerId) {
                        this.enableAndLoadFiles();
                    }
                },
                (error) => {
                    this.spinner.close();
                    this.toast.showError(error);
                }
            );
    }

    private initializeFileSearch(): void {
        this.fileControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            map(value => typeof value === 'string' ? value : value?.fileName ?? ''),
            tap(value => {
                if (this.selectedFile && value !== this.selectedFile.fileName) {
                    this.selectedFile = null;
                }
            }),
            debounceTime(400),
            distinctUntilChanged()
        ).subscribe(value => {
            this.fileOptions = this.filterLoadedFiles(value);
        });
    }

    onPartnerChange(): void {
        this.clearFileSelection();
        this.clearResults();
        if (this.selectedPartnerId) {
            this.enableAndLoadFiles();
        } else {
            this.fileControl.disable({emitEvent: false});
        }
    }

    private enableAndLoadFiles(): void {
        this.fileControl.enable({emitEvent: false});
        this.loadProcessedFiles();
    }

    private loadProcessedFiles(): void {
        this.loadingFiles = true;
        const requests = this.allowedFileStatuses.map(status =>
            this.fetchProcessedFilesByStatus(status).pipe(
                catchError(() => of([]))
            )
        );

        forkJoin(requests).pipe(
            map(groups => {
                const unique = new Map<number, FileProcess>();
                groups.flat().forEach(file => unique.set(file.id, file));
                return Array.from(unique.values()).sort((a, b) =>
                    (a.fileName ?? '').localeCompare(b.fileName ?? '', undefined, {sensitivity: 'base'})
                );
            }),
            finalize(() => this.loadingFiles = false)
        ).subscribe(files => {
            this.allFileOptions = files;
            this.fileOptions = this.filterLoadedFiles(this.displayFile(this.fileControl.value));
            this.restorePendingFileSelection(files);
        });
    }

    private fetchProcessedFilesByStatus(status: string): Observable<FileProcess[]> {
        const requestPage = (pageIndex: number) => {
            const params = new HttpParams()
                .set('partnerId', String(this.selectedPartnerId))
                .set('processStatus', status)
                .set('pageIndex', String(pageIndex))
                .set('pageSize', '100');
            return this.batchProcessingService.getAll(params);
        };

        return requestPage(0).pipe(
            expand(page => page.pager?.last ? EMPTY : requestPage(page.pager.pageIndex + 1)),
            map(page => page.result ?? []),
            reduce((all, pageRows) => all.concat(pageRows), [] as FileProcess[])
        );
    }

    private filterLoadedFiles(search: string): FileProcess[] {
        const normalized = (search ?? '').toString().trim().toLocaleLowerCase();
        if (!normalized) {
            return this.allFileOptions;
        }
        return this.allFileOptions.filter(file =>
            (file.fileName ?? '').toLocaleLowerCase().includes(normalized)
        );
    }

    selectFile(file: FileProcess): void {
        this.selectedFile = file;
        this.pendingFileProcessId = null;
    }

    displayFile(file: FileProcess | string | null): string {
        return typeof file === 'string' ? file : file?.fileName ?? '';
    }

    getFileNameParts(fileName: string): {before: string; match: string; after: string} {
        const search = typeof this.fileControl.value === 'string' ? this.fileControl.value.trim() : '';
        if (!search) { return {before: fileName, match: '', after: ''}; }
        const index = fileName.toLocaleLowerCase().indexOf(search.toLocaleLowerCase());
        if (index < 0) { return {before: fileName, match: '', after: ''}; }
        return {
            before: fileName.slice(0, index),
            match: fileName.slice(index, index + search.length),
            after: fileName.slice(index + search.length)
        };
    }

    formatProcessedFileDate(value: string): string {
        if (!value) { return ''; }
        return new Intl.DateTimeFormat('es-PA', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit', hour12: false
        }).format(new Date(value)).replace(',', '');
    }

    private restorePendingFileSelection(files: FileProcess[]): void {
        if (!this.pendingFileProcessId) { return; }
        const file = files.find(item => item.processedFileId === this.pendingFileProcessId);
        if (file) {
            this.selectedFile = file;
            this.fileControl.setValue(file, {emitEvent: false});
            this.pendingFileProcessId = null;
        }
    }

    private clearFileSelection(): void {
        this.selectedFile = null;
        this.pendingFileProcessId = null;
        this.allFileOptions = [];
        this.fileOptions = [];
        this.fileControl.setValue('', {emitEvent: false});
    }

    private clearResults(): void {
        this.dataSource = [];
        this.tableService.pager.pageIndex = 0;
        this.tableService.pager.totalEntities = 0;
    }

    private formatDateToISO(dateStr: string): string {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}${day}${year}`;
    }

    private validateFilters(): boolean {
        if (!this.selectedPartnerId) {
            this.toast.showInfo(this.translate.instant('appliedCharges.messages.selectCompany'));
            return false;
        }
        if (this.selectedFile && !this.selectedFile.processedFileId) {
            this.toast.showInfo(this.translate.instant('appliedCharges.messages.fileWithoutProcessedId'));
            return false;
        }
        if (!this.filter.from) {
            this.toast.showInfo(this.translate.instant('appliedCharges.messages.selectFromDate'));
            return false;
        }
        if (!this.filter.to) {
            this.toast.showInfo(this.translate.instant('appliedCharges.messages.selectToDate'));
            return false;
        }
        if (!this.filter.chargeStatus) {
            this.toast.showInfo(this.translate.instant('appliedCharges.messages.selectChargeStatus'));
            return false;
        }

        const fromDate = new Date(this.filter.from);
        const toDate = new Date(this.filter.to);
        if (fromDate > toDate) {
            this.toast.showError(this.translate.instant('appliedCharges.messages.dateRangeError'));
            return false;
        }
        return true;
    }

    search(): void {
        if (!this.canViewAppliedCharges()) {
            this.toast.showWarning('No tienes permisos para consultar cargos aplicados.');
            return;
        }

        if (!this.validateFilters()) return;

        this.filter.partnerId = this.selectedPartnerId;
        this.filter.processedFileId = this.selectedFile?.processedFileId ?? undefined;
        this.tableService.pager.pageIndex = 0;
        this.appliedChargeStatus = this.filter.chargeStatus ?? null;
        this.updateDisplayedColumns();
        this.list();
    }

    private getMockData(): any {
        const mockResult = [
            {
                partnerName: 'Empresa Demo S.A.',
                invoiceCode: 'FAC-001-2026',
                identifierCustomer: '8-888-1234',
                clientName: 'Juan Pérez',
                chargeType: 'Suscripción mensual',
                totalInvoice: 49.99,
                itbms: 3.50,
                currency: 'USD',
                mask: '**** **** **** 4242',
                createdAtInvoice: '2026-05-05',
                approvalDate: '2026-05-05',
                authorizationNumber: 'REF-ABC-123456'
            },
            {
                partnerName: 'Empresa Demo S.A.',
                invoiceCode: 'FAC-002-2026',
                identifierCustomer: '8-888-5678',
                clientName: 'María López',
                chargeType: 'Suscripción premium',
                totalInvoice: 99.99,
                itbms: 7.00,
                currency: 'USD',
                mask: '**** **** **** 1234',
                createdAtInvoice: '2026-05-06',
                approvalDate: '2026-05-06',
                authorizationNumber: 'REF-DEF-789012'
            },
            {
                partnerName: 'Tech Solutions Corp',
                invoiceCode: 'FAC-003-2026',
                identifierCustomer: 'PE-123456',
                clientName: 'Carlos García',
                chargeType: 'Pago único',
                totalInvoice: 199.99,
                itbms: 13.99,
                currency: 'USD',
                mask: '**** **** **** 5678',
                createdAtInvoice: '2026-05-07',
                approvalDate: '2026-05-07',
                authorizationNumber: 'REF-GHI-345678'
            }
        ];

        return {
            result: mockResult,
            pager: {
                totalEntities: mockResult.length,
                totalEntitiesPerPage: mockResult.length,
                pageIndex: 0,
                pageSize: 20,
                pages: 1,
                startIndex: 0,
                endIndex: mockResult.length - 1
            }
        };
    }

    list(event?: PageEvent): void {
        if (!this.canViewAppliedCharges()) {
            this.toast.showWarning('No tienes permisos para consultar cargos aplicados.');
            this.clearResults();
            return;
        }

        if (event) {
            this.tableService.pager.pageIndex = event.pageIndex;
            this.tableService.pager.pageSize = event.pageSize;
        }

        this.spinner.open();

        if (this.useMock) {
            setTimeout(() => {
                const response = this.getMockData();
                this.dataSource = new MatTableDataSource<any>(response['result']);
                this.tableService.pager = response['pager'];
                this.tableService.selection.clear();
                this.spinner.close();
            }, 500);
            return;
        }

        let httpParams = new HttpParams()
            .set('collection', 'm')
            .set('pageIndex', this.tableService.pager.pageIndex.toString())
            .set('pageSize', this.tableService.pager.pageSize.toString());

        // Formatear fechas solo al construir params, sin modificar el filter
        const paramsFilter = new AppliedChargesFilter(this.filter);
        paramsFilter.processedFileId = this.selectedFile?.processedFileId ?? undefined;
        paramsFilter.from = this.formatDateToISO(this.filter.from as string);
        paramsFilter.to = this.formatDateToISO(this.filter.to as string);
        httpParams = paramsFilter.getHttpParams(httpParams);

        this.webService.get(
            this.webService.HOST + "/api/v2/transactions/reports/applied-charges",
            httpParams
        ).subscribe(response => {
            if (response['result'] && response['result'].length === 0) {
                this.toast.showWarning(this.translate.instant('appliedCharges.messages.noResultsShow'));
            }

            this.dataSource = new MatTableDataSource<any>(response['result'] || []);
            this.tableService.pager = response['pager'];
            this.tableService.selection.clear();

            // Sincronizar URL después de la respuesta exitosa
            this.syncUrlQueryParams();
            this.spinner.close();
        }, (err) => {
            this.spinner.close();
            this.toast.showError(err);
        });
    }

    reset(): void {
        this.filter = new AppliedChargesFilter();
        this.tableService.filter = null;
        this.dataSource = [];
        this.selectedPartnerId = undefined;
        this.clearFileSelection();
        this.fileControl.disable({emitEvent: false});
        this.tableService.pager.pageIndex = 0;
        this.appliedChargeStatus = null;
        this.updateDisplayedColumns();
        this.syncUrlQueryParams();
    }

    openSearchPanel(value: boolean) {
        this.isOpenSearchPanel = value;
        this.filter = new AppliedChargesFilter(this.filter);
    }

    goBack() {
        this.router.navigate(["/my-portals"]);
    }

    private fetchAllData(): any {
        this.spinner.open();

        if (this.useMock) {
            return {
                subscribe: (callbacks: any) => {
                    setTimeout(() => {
                        const response = this.getMockData();
                        if (callbacks && typeof callbacks === 'function') {
                            callbacks(response);
                        } else if (callbacks?.next) {
                            callbacks.next(response);
                        }
                    }, 500);
                }
            } as any;
        }

        // Traer todos los registros
        let httpParams = new HttpParams()
            .set('collection', 'm')
            .set('pageIndex', '-1')
            .set('pageSize', '-1');

        // Formatear fechas solo al construir params
        const paramsFilter = new AppliedChargesFilter(this.filter);
        paramsFilter.processedFileId = this.selectedFile?.processedFileId ?? undefined;
        paramsFilter.from = this.formatDateToISO(this.filter.from as string);
        paramsFilter.to = this.formatDateToISO(this.filter.to as string);
        httpParams = paramsFilter.getHttpParams(httpParams);

        return this.webService.get(
            this.webService.HOST + "/api/v2/transactions/reports/applied-charges",
            httpParams
        );
    }

    private getTodayFormatted(): string {
        const today = new Date();
        return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    }

    get actionsDisabled(): boolean {
        return !this.canViewAppliedCharges() || !this.selectedPartnerId || !this.filter.from || !this.filter.to || !this.filter.chargeStatus;
    }

    canViewAppliedCharges(): boolean {
        return this.userPermissionsService.hasPermission('controllers.Invoices.listInvoicesCharged');
    }

    private getExcelFileName(): string {
        const original = this.selectedFile?.fileName ?? '';
        const withoutExtension = original.replace(/\.[^/.]+$/, '');
        const sanitized = withoutExtension.replace(/[<>:"/\\|?*\u0000-\u001F]/g, '_').trim();
        return `${sanitized || 'cargos_aplicados'}_${this.getTodayFormatted()}.xlsx`;
    }

    private formatExcelReportDate(date: Date): string {
        const pad2 = (n: number) => String(n).padStart(2, '0');
        const day = pad2(date.getDate());
        const month = pad2(date.getMonth() + 1);
        const year = date.getFullYear();
        const hours24 = date.getHours();
        const minutes = pad2(date.getMinutes());
        const isAm = hours24 < 12;
        const hours12 = hours24 % 12 === 0 ? 12 : hours24 % 12;
        return `${day}/${month}/${year} ${pad2(hours12)}.${minutes} ${isAm ? 'a' : 'p'}`;
    }

    private formatExcelShortDate(dateStr: string): string {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        const m = d.getMonth() + 1;
        const day = d.getDate();
        const yy = String(d.getFullYear()).slice(-2);
        return `${m}/${day}/${yy}`;
    }

    private getSelectedPartnerName(): string {
        const partner = this.partners?.find(p => String(p?.id) === String(this.selectedPartnerId));
        return partner?.name || partner?.name_partner || partner?.business_name || partner?.partnerName || partner?.companyName || '';
    }

    private getExportColumns(): Array<{ key?: string; header: string; width: number }> {
        return this.showErrorDescriptionColumn
            ? [...this.EXPORT_COLUMNS, { key: 'resultDescription', header: 'Descripción del error', width: 28 }]
            : this.EXPORT_COLUMNS;
    }

    private buildExportDataRow(item: any): any[] {
        return this.getExportColumns().map(column => column.key ? this.getDisplayValue(item, column.key) : '');
    }

    private buildExportHeaderRows(): any[][] {
        const now = new Date();
        const fromShort = this.formatExcelShortDate(this.filter.from as string);
        const toShort = this.formatExcelShortDate(this.filter.to as string);
        const partnerName = this.getSelectedPartnerName();

        return [
            this.padExportRow(['Reporte']),
            this.padExportRow([
                'Fecha del Reporte', '', '', this.formatExcelReportDate(now), '', '', '', '',
                'Rango de', 'Del', '', fromShort, '', 'al', toShort, '', '', '', '', 'Página', 1
            ]),
            this.padExportRow(['', '', '', '', '', '', '', '', 'Comercio', partnerName]),
            this.getExportColumns().map(column => column.header)
        ];
    }

    private padExportRow(values: any[]): any[] {
        return Array.from({ length: this.getExportColumns().length }, (_, index) => values[index] ?? '');
    }

    private csvCell(value: any): string {
        const cellStr = String(value ?? '');
        if (cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n')) {
            return `"${cellStr.replace(/"/g, '""')}"`;
        }
        return cellStr;
    }

    private prepareRows(data: any[]): any[] {
        return data.map((item: any) => {
            const row: any = {};
            for (const key of this.displayedColumns) {
                row[this.HEADER_MAPPING[key] || key] = this.getDisplayValue(item, key);
            }
            return row;
        });
    }

    getDisplayValue(row: any, key: string): any {
        if (key === 'partnerName') {
            return row?.serviceName || row?.partnerName || '';
        }
        if (key === 'resultDescription') {
            return row?.resultDescription || row?.result_description || row?.paymentResultDescription || '';
        }
        return row?.[key] ?? '';
    }

    formatTableDateTime(value: string): string {
        if (!value || value === 'N/A') {
            return value || '';
        }

        const normalized = value.replace(' ', 'T').replace(/\.\d+$/, '');
        const date = new Date(normalized);

        if (isNaN(date.getTime())) {
            return value;
        }

        return new Intl.DateTimeFormat('es-PA', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(date).replace(',', '');
    }

    truncateText(value: string, maxLength = this.ERROR_DESCRIPTION_MAX_LENGTH): string {
        if (!value || value.length <= maxLength) {
            return value || '';
        }

        return `${value.slice(0, maxLength).trim()}...`;
    }

    shouldShowTooltip(value: string, maxLength = this.ERROR_DESCRIPTION_MAX_LENGTH): boolean {
        return !!value && value.length > maxLength;
    }

    formatAmount(value: number | string): string {
        if (value === null || value === undefined || value === '') {
            return '';
        }

        const amount = Number(value);
        if (isNaN(amount)) {
            return String(value);
        }

        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
    }

    private async downloadExcelWithFormat(data: any[], fileName: string): Promise<void> {
        const ExcelJS = await import('exceljs');
        const Workbook = (ExcelJS as any).Workbook ?? (ExcelJS as any).default?.Workbook;
        if (!Workbook) {
            throw new Error('No se pudo cargar ExcelJS.Workbook');
        }

        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Cargos Aplicados');

        worksheet.columns = this.getExportColumns().map((column, index) => ({
            key: `col${index + 1}`,
            width: column.width
        }));

        this.buildExportHeaderRows().forEach(row => worksheet.addRow(row));
        [1, 2, 3, 4].forEach(rowNumber => {
            worksheet.getRow(rowNumber).eachCell(cell => {
                cell.font = { bold: true, size: rowNumber === 1 ? 22 : 12 };
            });
        });

        data.forEach((item: any) => {
            worksheet.addRow(this.buildExportDataRow(item));
        });

        const buf = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    downloadExcel(): void {
        if (!this.canViewAppliedCharges()) {
            this.toast.showWarning('No tienes permisos para descargar cargos aplicados.');
            return;
        }

        if (!this.validateFilters()) return;

        this.filter.partnerId = this.selectedPartnerId;
        this.fetchAllData().subscribe(response => {
            const data = response['result'];
            if (!data || data.length === 0) {
                this.toast.showWarning(this.translate.instant('appliedCharges.messages.noResultsDownload'));
                this.spinner.close();
                return;
            }

            const fileName = this.getExcelFileName();
            this.downloadExcelWithFormat(data, fileName)
                .then(() => {
                    this.spinner.close();
                    this.toast.showSuccess(this.translate.instant('appliedCharges.messages.downloadSuccess'));
                })
                .catch((err) => {
                    this.spinner.close();
                    this.toast.showError(err);
                });
        }, (err) => {
            this.spinner.close();
            this.toast.showError(err);
        });
    }

    downloadCsv(): void {
        if (!this.canViewAppliedCharges()) {
            this.toast.showWarning('No tienes permisos para descargar cargos aplicados.');
            return;
        }

        if (!this.validateFilters()) return;

        this.filter.partnerId = this.selectedPartnerId;
        this.fetchAllData().subscribe(response => {
            const data = response['result'];
            if (!data || data.length === 0) {
                this.toast.showWarning(this.translate.instant('appliedCharges.messages.noResultsDownload'));
                this.spinner.close();
                return;
            }

            const rows = [
                ...this.buildExportHeaderRows(),
                ...data.map((item: any) => this.buildExportDataRow(item))
            ];

            const csvContent = rows
                .map(row => row.map(cell => this.csvCell(cell)).join(','))
                .join('\n') + '\n';

            const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.setAttribute('href', url);
            link.setAttribute('download', `cargos_aplicados_${this.getTodayFormatted()}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            this.spinner.close();
            this.toast.showSuccess(this.translate.instant('appliedCharges.messages.downloadSuccess'));
        }, (err) => {
            this.spinner.close();
            this.toast.showError(err);
        });
    }
}
